/**
 * Best-effort one-line label for a tool call, derived from its input. Shared by
 * the live stream (copilot-panel, object input) and persisted messages
 * (chat-message, raw JSON string) so the preferred-key list stays in one place.
 */

const PREF_KEYS = ["title", "name", "id", "uid", "query", "path", "slug"];

/** Pull a one-line target out of a parsed tool-call input object, best-effort. */
export function summarizeInput(input: unknown): string | undefined {
  if (!input || typeof input !== "object") return undefined;
  const obj = input as Record<string, unknown>;
  for (const k of PREF_KEYS) {
    const v = obj[k];
    if (typeof v === "string" && v.trim()) return v;
  }
  const first = Object.values(obj).find(
    (v) => typeof v === "string" && (v as string).trim(),
  );
  return typeof first === "string" ? first : undefined;
}

/** Same, from a tool call's raw input JSON string. */
export function summarizeInputJson(
  inputJson: string | null,
): string | undefined {
  if (!inputJson) return undefined;
  try {
    return summarizeInput(JSON.parse(inputJson));
  } catch {
    return undefined;
  }
}
